import { colors } from '~/layout';
import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  background-color: ${colors.white};
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;

  .addContact {
    position: absolute;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
  }

  .rowContacts {
    min-height: 52px;
    margin-bottom: 7px;
  }
`;

export const Block = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
`;

export const Right = lib.styled.div`
  position: absolute;
  right: 10px;
`;
